<template>
    <div class="container-fluid">
        <!-- ตารางแพคเกจโปรโมชั่น -->
        <MPropack1View :key="countRefresh"
          @onRefreshAfterUpdate="refreshAfterUpdate"/>
    </div>
</template>

<script>
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import MPropack1View from './MPropack1View.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Propack',
  components: {
    MPropack1View
  },
  data () {
    return {
      index: 0,
      action: 'new',
      countRefresh: 0
    }
  },
  mounted () {

  },
  methods: {
    // หลังจาก เพิ่ม หรือ จัดลำดับ ชุดตรวจในแพคเกจ : Refresh Table ด้านขวา
    refreshAfterUpdate () {
      this.countRefresh++
    }
  }
}

</script>

<style>

</style>
